import { render, staticRenderFns } from "./_userId.vue?vue&type=template&id=f8036348&scoped=true&"
import script from "./_userId.vue?vue&type=script&lang=js&"
export * from "./_userId.vue?vue&type=script&lang=js&"
import style0 from "./_userId.vue?vue&type=style&index=0&id=f8036348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8036348",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
